import { createFeatureSelector, createSelector } from '@ngrx/store';

import { UPSELLING_STORE_KEY, UpsellingState } from './upselling.state';
import { UpsellingMapping, UpsellingProposal } from './upselling.model';
import { SELECT_SHOP_ACTIVE_PRODUCTS } from '@store/shop';

// Feature selector
export const selectUpsellingFeature = createFeatureSelector<UpsellingState>(UPSELLING_STORE_KEY);

// Basic selectors
export const selectUpsellingData = createSelector(
  selectUpsellingFeature,
  (state: UpsellingState) => state.data,
);

export const selectUpsellingIsLoaded = createSelector(
  selectUpsellingFeature,
  (state: UpsellingState) => state.isLoaded,
);

export const selectUpsellingIsLoading = createSelector(
  selectUpsellingFeature,
  (state: UpsellingState) => state.isLoading,
);

export const selectUpsellingHasError = createSelector(
  selectUpsellingFeature,
  (state: UpsellingState) => state.hasError,
);

export const selectUpsellingError = createSelector(
  selectUpsellingFeature,
  (state: UpsellingState) => state.error,
);

// Computed selectors
export const selectUpsellingMappings = createSelector(
  selectUpsellingData,
  data => data?.proposals ?? [],
);

export const selectUpsellingMappingByTriggerProductId = (triggerProductId: string) =>
  createSelector(selectUpsellingMappings, (mappings: UpsellingMapping[]) =>
    mappings.find((mapping: UpsellingMapping) => mapping.triggerProductId === triggerProductId),
  );

const selectUpsellingProposalsByTriggerProductId = (triggerProductId: string) =>
  createSelector(
    selectUpsellingMappingByTriggerProductId(triggerProductId),
    mapping => mapping?.proposals ?? [],
  );

export const selectUpsellingProposalsProductsByTriggerProductId = (triggerProductId: string) => {
  return createSelector(
    selectUpsellingProposalsByTriggerProductId(triggerProductId),
    SELECT_SHOP_ACTIVE_PRODUCTS,
    (proposals: UpsellingProposal[], products) => {
      if (!products) return [];
      const proposalProductIds = proposals.map((proposal: UpsellingProposal) => proposal.productId);
      return products
        .filter(product => proposalProductIds.includes(product.id))
        .sort((a, b) => {
          const indexA = proposalProductIds.indexOf(a.id);
          const indexB = proposalProductIds.indexOf(b.id);
          return indexA - indexB;
        });
    },
  );
};
